<template>
  <!-- Use the Preloader component here -->
  <Preloader :isVisible="isPreloaderVisible" />
  <!-- Include the HeaderTop component -->
  <Header />

  <!-- Main app content -->
  <FreePopup />
  <div class="main-body">
    <Sidebar />

    <!--Middle Body-->
    <div class="body-middle">
      <router-view :key="$route.fullPath" />

      <MobileNav />

      <Footer />
    </div>
    <!--Middle Body-->

    <Chatbar 
    v-if="$route.name !== 'game.show' && chatEnabled"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from 'jquery';
window.$ = window.jQuery = $;  // Make jQuery available globally

import Header from "@/components/layout/Header.vue";
import Preloader from "@/components/partials/Preloader.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import Chatbar from "@/components/layout/Chatbar.vue";
import Footer from "@/components/layout/Footer.vue";
import MobileNav from "@/components/layout/MobileNav.vue";
import { useAuthStore } from '@/store/auth'
import { eventBus } from '@/eventBus';
import { mapActions } from "pinia";
import helpers from "@/helpers";
import FreePopup from "@/components/layout/FreePopup.vue";
import { useHomeStore } from '@/store/home'

export default {
  name: "App",
  inject: ["isRtlLayout"],
  data() {
    return {
      isLoading: false,
      chatEnabled: true,
    };
  },
  components: {
    Header,
    Preloader,
    Sidebar,
    Chatbar,
    Footer,
    MobileNav,
    FreePopup,
  },
  setup() {
    const isPreloaderVisible = ref(true);

    onMounted(() => {
      window.addEventListener("load", () => {
        setTimeout(() => {
          isPreloaderVisible.value = false;
        }, 1000);
      });
    });

    return {
      isPreloaderVisible,
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["autoLogin", "clearData", "updateLastPlay"]),
    ...mapActions(useHomeStore, ['fetchConfigData']),
  },
  async created() {
    this.chatEnabled = helpers.getDomainConfig().chatEnabled;

    eventBus.on('loading', (loading) => {
      this.isLoading = loading;
    });

    const configStatus = await this.fetchConfigData();
    if (configStatus == "config-exist" || configStatus == "config-loaded") {
      if (configStatus == "config-loaded") {
        location.reload();
      }
      const phone = localStorage.getItem("phone");

      if (phone) {
        await this.autoLogin(phone);
      } else {
        this.clearData();
      }

      setInterval(async () => {
        await this.updateLastPlay();
      }, 30000);
    } else {
      // Show error page...
      helpers.showToast(
        this.$t("Sorry this system is not configured, please contact admin"),
        this.$t("Error"),
        "error"
      );
    }
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}
</style>
